import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  CircularProgress,
  Box,
  TextField,
  Typography,
  Button,
  Grid,
  TableContainer,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import { useLazyGetExpenseDetailsQuery } from "../../../redux/api/expenses"; // 👈 use lazy
import { useSelector } from "react-redux";
import { selectCurrentagency } from "../../../redux/features/authSlice";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const ExpenseTable = ({ onEdit }) => {
  const currentAgency = useSelector(selectCurrentagency);

  const [fromdate, setFromdate] = useState("");
  const [todate, setTodate] = useState("");

  console.log(' todate fromdate',todate, fromdate)

  // 👇 lazy query with full state
  const [trigger, { data: rows = [], isLoading, isError, isFetching }] =
    useLazyGetExpenseDetailsQuery();

  // ✅ Auto load once on mount
  useEffect(() => {
    if (currentAgency?.agencyid) {
      const today = dayjs();
      setFromdate(today);
      setTodate(today);

      trigger({
        agencyid: currentAgency.agencyid,
        fromdate: today.format("YYYY-MM-DD"),
        todate: today.format("YYYY-MM-DD"),
      });
    }
  }, [currentAgency?.agencyid, trigger]);

  const handleEdit = (row, idx) => {
    if (onEdit) onEdit(row, idx);
  };

  const handleFetch = () => {
    if (!fromdate || !todate) return;
    trigger({
      agencyid: currentAgency.agencyid,
      fromdate,
      todate,
    });
  };

  return (

    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Paper sx={{ p: 2, borderRadius: 2 }} elevation={2}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Recent Expenses
      </Typography>

   

      <Grid
        container
        spacing={2}
        mb={2}
        alignItems="center"
       // left on mobile, right on tablet+
      >
        {/* From Date */}
       <Grid item xs={12} md={4}>
  <DatePicker
    label="From Date"
    value={fromdate}
    onChange={(newValue) => setFromdate(newValue)}
    slotProps={{
      textField: {
        size: "small",
        fullWidth: true,
        variant: "outlined",
      },
    }}
  />
</Grid>

<Grid item xs={12} md={4}>
  <DatePicker
    label="To Date"
    value={todate}
    onChange={(newValue) => setTodate(newValue)}
    slotProps={{
      textField: {
        size: "small",
        fullWidth: true,
        variant: "outlined",
      },
    }}
  />
</Grid>


        {/* Button */}
        <Grid item xs={12} md="auto">
          <Button
            variant="contained"
            color="primary"
            onClick={handleFetch}
            disabled={isFetching}
            sx={{
              whiteSpace: "nowrap",
              color: "white",
              position: "relative",
              minWidth: { xs: "100%", md: 140 }, // full width on mobile, fixed width tablet+
              py: "8px",
              height: 40,
            }}
            fullWidth={true}
          >
            <span style={{ visibility: isFetching ? "hidden" : "visible" }}>
              Load Expenses
            </span>

            {isFetching && (
              <CircularProgress
                size={20}
                sx={{
                  color: "white",
                  position: "absolute",
                }}
              />
            )}
          </Button>
        </Grid>
      </Grid>
   
      {isLoading ? (
        <Typography align="center" sx={{ p: 2 }}>
          <CircularProgress size={24} />
        </Typography>
      ) : isError ? (
        <Typography align="center" sx={{ p: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              p: 3,
              borderRadius: 2,
              bgcolor: "error.light",
              color: "error.contrastText",
              boxShadow: 3,
              maxWidth: 400,
              mx: "auto",
            }}
          >
            <ErrorOutlineIcon sx={{ fontSize: 40 }} />
            <Typography variant="h6" fontWeight="bold">
              Failed to load expenses
            </Typography>
            <Typography variant="body2">
              Something went wrong. Please try again later.
            </Typography>
          </Box>
        </Typography>
      ) : (

              <TableContainer component={Paper} sx={{ mt: 3 }}>
                  <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Date</TableCell>
              <TableCell align="right">Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No records
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row, idx) => (
                <TableRow key={row.id || idx}>
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell>{row.ExpenseTypeName}</TableCell>
                  <TableCell>{row.amount}</TableCell>
                  <TableCell>
                    {row.expdate
                      ? dayjs(row.expdate).format("DD MMM YYYY")
                      : "-"}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() => handleEdit(row, idx)}
                    >
                      <EditIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
              </TableContainer>
      
      )}
    </Paper>
    </LocalizationProvider>
  
  );
};

export default ExpenseTable;
